import { ref, computed } from 'vue'

export type DrawerName = 'left' | 'right'

export type DrawerState = {
    [key in DrawerName]: boolean
}

const drawerState = ref<DrawerState>({
    left: false,
    right: false,
})

export function useNavigationDrawers() {
    const toggleDrawer = (name: DrawerName) => {
        drawerState.value[name] = !drawerState.value[name]
    }

    const openDrawer = (name: DrawerName) => {
        drawerState.value[name] = true
    }

    const closeDrawer = (name: DrawerName) => {
        drawerState.value[name] = false
    }

    const isDrawerOpen = (name: DrawerName) => {
        return computed(() => drawerState.value[name])
    }

    return {
        toggleDrawer,
        openDrawer,
        closeDrawer,
        isDrawerOpen,
    }
}